import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const HttpInterceptor: HttpInterceptorFn = (req, next) => {
  const match = /^(\/(api|auth).+)/;

  const clientReq = req.clone({
    url: req.url.replace(match, `${environment.host}$1`),
  });

  return next(clientReq);
};
